/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_S3Inputs */

const en_tut_wakil_s3 = /** @type {(inputs: Tut_Wakil_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick who urgent things escalate to, and a daily reply limit. Then press **Simpan**.`)
};

const id_tut_wakil_s3 = /** @type {(inputs: Tut_Wakil_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentukan **Eskalasi hal mendesak ke** seorang rekan, dan **Batas jawaban per hari**. Lalu tekan **Simpan**.`)
};

/**
* | output |
* | --- |
* | "Pick who urgent things escalate to, and a daily reply limit. Then press **Simpan**." |
*
* @param {Tut_Wakil_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_s3 = /** @type {((inputs?: Tut_Wakil_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_s3(inputs)
	return en_tut_wakil_s3(inputs)
});